export default __webpack_public_path__ + "static/media/primary.017e5995246d8bd6c75abb89d04dbcf4.svg";